function checkParents(items, eventTarget) {
    var realItem;
    items.forEach((item) => {
        if (item === eventTarget) {
            realItem = item;
            return;
        }
        var parent = eventTarget.parentNode;
        while (parent !== document) {
            if (item === parent) {
                realItem = item;
                return;
            }
            parent = parent.parentNode;
        }
    });
    return realItem;
}
export class Collection {
    constructor(selector) {
        this.elements = [];
        if (typeof selector == 'number')
            return;
        if (selector instanceof Collection)
            return selector;
        var elements = selector;
        if (typeof selector === 'string')
            elements = document.querySelectorAll(selector);
        if (elements) {
            if (elements.nodeType || elements === window)
                elements = [elements];
            this.elements = Array.prototype.slice.call(elements);
            ;
        }
    }
    [Symbol.iterator]() {
        return this.elements[Symbol.iterator]();
    }
    get(index) {
        index = Number(index);
        return this.elements[index < 0 ? index + this.elements.length : index];
    }
    ;
    get length() {
        return this.elements.length;
    }
    /* Class */
    hasClass(className) {
        return this.elements[0].classList.contains(className);
    }
    addClass(classNames) {
        var classNameList = classNames.split(' ');
        this.forEach((item) => {
            item.classList.add(...classNameList);
        });
        return this;
    }
    removeClass(classNames) {
        var classNameList = classNames.split(' ');
        this.forEach((item) => {
            item.classList.remove(...classNameList);
        });
        return this;
    }
    toggleClass(className) {
        this.forEach((item) => {
            item.classList.toggle(className);
        });
        return this;
    }
    data(name, value) {
        if (!value) {
            return this.elements[0].dataset[name];
        }
        else {
            this.elements.forEach((item) => {
                item.dataset[name] = value;
            });
            return this;
        }
    }
    /* HTML */
    empty() {
        this.elements.forEach((item) => {
            while (item.firstChild)
                item.removeChild(item.firstChild);
        });
        return this;
    }
    prepend(items) {
        items.forEach((item) => {
            this.elements[0].insertBefore(item, this.elements[0].firstChild);
        });
        return this;
    }
    append(items) {
        items.forEach((item) => {
            this.elements[0].appendChild(item);
        });
        return this;
    }
    prev() {
        var collection = new Collection();
        this.forEach((item) => {
            collection.add(item.previousElementSibling);
        });
        return collection;
    }
    next() {
        var collection = new Collection();
        this.forEach((item) => {
            collection.add(item.nextElementSibling);
        });
        return collection;
    }
    parent() {
        return new Collection(this.get(0).parentNode);
    }
    parents(selector) {
        var current = this.elements[0];
        var list = new Collection();
        while (current.parentNode != null && current.parentNode != document.documentElement) {
            let isToBeAdded = true;
            if (selector) {
                isToBeAdded = false;
                if (current.parentNode.matches(selector))
                    isToBeAdded = true;
            }
            if (isToBeAdded)
                list.add(current.parentNode);
            current = current.parentNode;
        }
        return list;
    }
    val(value) {
        if (typeof value != 'string' && typeof value != 'number') {
            return this.elements[0].value;
        }
        else {
            this.elements.forEach((item) => {
                item.value = value.toString();
            });
            return this;
        }
        return this;
    }
    html(value) {
        if (typeof value != 'string' && typeof value != 'number') {
            return this.elements[0].innerHTML;
        }
        else {
            this.elements.forEach((item) => {
                item.innerHTML = value.toString();
            });
            return this;
        }
        return this;
    }
    text(value) {
        if (typeof value != 'string' && typeof value != 'number') {
            return this.elements[0].textContent;
        }
        else {
            this.elements.forEach((item) => {
                item.textContent = value.toString();
            });
            return this;
        }
        return this;
    }
    attr(name, value) {
        if (!value) {
            return this.elements[0].getAttribute(name);
        }
        else {
            this.elements.forEach((item) => {
                item.setAttribute(name, value);
            });
            return this;
        }
    }
    /* Collection */
    forEach(callback, thisArg) {
        this.elements.forEach(callback);
    }
    add(newItem) {
        var isAlreadyInCollection = false;
        this.forEach((item) => {
            if (newItem === item)
                isAlreadyInCollection = true;
        });
        if (!isAlreadyInCollection)
            this.elements.push(newItem);
    }
    search(selector) {
        var filteredElement = new Collection();
        this.forEach((item) => {
            if (item.matches(selector))
                filteredElement.add(item);
        });
        return filteredElement;
    }
    find(selector) {
        var collection = new Collection();
        var foundElements = this.elements[0].querySelectorAll(selector);
        foundElements.forEach((element) => {
            collection.add(element);
        });
        return collection;
    }
    on(eventNames, selector, callback) {
        if (typeof eventNames == 'string')
            eventNames = [eventNames];
        if (typeof selector == 'function')
            callback = selector;
        eventNames.forEach((eventName) => {
            this.forEach((item) => {
                item.addEventListener(eventName, function (event) {
                    if (typeof selector == 'string') {
                        var realTarget = checkParents(new Collection(selector), event.target);
                        if (realTarget)
                            callback.call(realTarget, event, realTarget);
                    }
                    else {
                        callback.call(this, event, this);
                    }
                });
            });
        });
        return this;
    }
    trigger(eventName, eventData) {
        const event = document.createEvent('HTMLEvents');
        event.initEvent(eventName, true, false);
        event.data = eventData;
        this.forEach((item) => {
            item.dispatchEvent(event);
        });
    }
}
